import { Autocomplete, TextField } from "@mui/material";
import type { StorageLocationView } from "adl-gen/ferovinum/app/api";
import type { FC } from "react";

export const LocationInput: FC<{
  selectedLocation?: StorageLocationView;
  locations: StorageLocationView[];
  onChange: (v: StorageLocationView | null) => void;
}> = ({ selectedLocation, locations, onChange }) => {
  return (
    <Autocomplete<StorageLocationView>
      fullWidth={false}
      value={selectedLocation ?? null}
      onChange={(_e, value) => onChange(value)}
      getOptionLabel={(loc: StorageLocationView) =>
        loc.storageLocationName || ""
      }
      options={locations}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select storage location"
          name="location"
          required
        />
      )}
      isOptionEqualToValue={(option, value) => option.id === value.id}
    />
  );
};
